module.exports = __webpack_public_path__ + "media/images/category/feature/poj/logo-poj-a80e4fcb9ba28021d7888ed24c36c72e.svg";